var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-editor"},[_c('div',{staticClass:"document-editor-header"},[_c('div',{ref:"editorToolbar",staticClass:"document-editor-toolbar"})]),_c('div',{staticClass:"document-editor-body"},[_c('div',{ref:"ckeditor"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }